var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.isShowMenu('menu:system_home'))?_c('system-home'):_c('tenant-home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }